import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbPagination, NgbPaginationNext, NgbPaginationPrevious } from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';

@Component({
	selector: 'maj-tableless-pagination',
	imports: [
		NgbPagination,
		NgbPaginationPrevious,
		NgbPaginationNext,
		NgClass,
	],
	templateUrl: './tableless-pagination.component.html',
})
export class TablelessPaginationComponent {
	@Input({required: false})
	classes: string = '';

	@Input({required: false})
	pageSize: number = 10;

	@Input({required: true})
	totalItems!: number;

	@Input({required: false})
	currentPage: number = 1;

	@Input({required: false})
	maximumPages: number = 5;

	@Output()
	currentPageChange = new EventEmitter<number>();
}
